
import React, { useEffect, useRef, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { kbdEvent } from "../utils/Utils";
import Spin from "../ui/Spin";
import Float from "../ui/Float";
import Button from "../ui/Button";
export default function ReportsInventorySearch(props) {

    const { controller = "", route = "", callback = () => { }, setReportSearch= () => {} } = props;

    const ref = useRef(null);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState(false);

    const search = (_search = "") => {
        setReportSearch(keyword)
        callback(false)
    }

    useEffect(() => {
        if(ref?.current){
            ref.current.focus()
        }
    }, [])
    // Keyboard Events
    useEffect(() => {
        if (loading) {
            return;
        }
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { props.callback(false) } },
            { key: KBD.ENTER, action: (e) => { search() } },
            { key: KBD.PAGE_DOWN, action: (e) => { search(); } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [loading, keyword]);

    // Draw
    return (
        <Spin style={{ "margin": "0px -10px" }} loading={loading}>
            <div style={{ "width": "412px", "padding": "0px 10px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={"selected"} width={80}>Keywords</Label>
                    <Input ref={ref} search placeholder="Search report..." autoselect onChange={(e) => setKeyword(e)} width={300} edit onSearch={() => kbdEvent(KBD.ENTER)} value={search} />
                </Space>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <Float>
                        <div style={{ "padding": "0px 10px" }}></div>
                        <div style={{ "padding": "0px 10px" }}>
                            <Button style={{ "width": "100px" }} onClick={() => kbdEvent(KBD.ENTER)} styled>Search</Button>
                        </div>
                    </Float>
                </div>
            </div>
        </Spin>
    )
}